import { yup } from '@guiker/yup-util'

export const uidQueryParamsSchema = yup.object({
  uid: yup.string().required(),
})

export type UidQueryParamsSchema = yup.InferType<typeof uidQueryParamsSchema>
